import { Controller } from "stimulus";

export default class extends Controller {
  declare inputTarget: HTMLInputElement;
  declare labelTarget: HTMLSpanElement;

  // States of input forms:
  // Unvisited / visited
  // Empty / Valid / Invalid

  static get targets() {
    return ["input", "label"];
  }

  public setValid() {
    // TODO: migrate from DataMaps to Values
    this.data.set("state", "valid");
    // TODO: use new Stimulus Classes API
    // https://stimulus.hotwired.dev/reference/css-classes
    this.labelTarget.classList.remove("form-invalid");
    this.labelTarget.textContent = "";
  }

  public setInvalid() {
    // TODO: migrate from DataMaps to Values
    this.data.set("state", "invalid");
    this.labelTarget.classList.add("form-invalid");
    const validationMessage = this.inputTarget.validationMessage;
    this.labelTarget.innerText = validationMessage;
  }

  public validate() {
    if (!this.inputTarget.checkValidity() && this.inputTarget.value !== "") {
      this.setInvalid();
    } else {
      this.setValid();
    }
  }
}
